<template>
  <div>
    <v-btn color="primary" class="elevation-0 ml-6" width="167px" dark :loading="isSelecting" @click="onUploadClick">
      <v-icon left>mdi-upload</v-icon>Upload Excel
    </v-btn>
    <input
      ref="uploader"
      type="file"
      class="d-none"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @change="onFileChanged"
    />
  </div>
</template>
<script>
import readXlsxFile from 'read-excel-file'
import { IMPORT_SCHEMA } from '../../helpers'
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash-es/get'

const TRANSFORM_DATA_KEYS = ['studentLearningMethods', 'studentProducts', 'studentDepartments']
const PHONE_ALIAS_KEY = 'phoneAlias'

export default {
  data: () => ({ isSelecting: false }),
  computed: { ...mapGetters({ configs: 'leadConfig/configs' }) },
  methods: {
    ...mapActions({
      fetchLeadProgress: 'lead/fetchLeadProgress',
      updateLeadProgress: 'lead/updateLeadProgress',
      setImportedItems: 'lead/setImportedItems',
    }),
    reset() {
      this.$refs.uploader.value = null
    },
    clickUploadSection() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onUploadClick() {
      this.$loading.active = true
      try {
        const progress = await this.fetchLeadProgress()
        await this.handleUploadProgress(progress)
      } catch (error) {
        console.error(error)
        this.$alert.error('Không kiểm tra được trạng thái upload. Xin vui lòng thử lại.')
      } finally {
        this.$loading.active = false
      }
    },
    async handleUploadProgress(progress) {
      if (!progress) {
        this.clickUploadSection()
        return
      }

      const statusHandlers = {
        available: () => this.clickUploadSection(),
        finish: () => this.handleFinishedUploadProgress(progress),
        creating: () => this.$emit('openProgressDialog'),
        error: () => this.handleFailedUploadProgress(progress),
      }
      const handleStatus = statusHandlers[progress.status]
      if (handleStatus) await handleStatus()
    },
    async handleFinishedUploadProgress(progress) {
      this.$alert.success('Thao tác upload trước đã thành công! Xin Vui lòng upload tiếp.')
      await this.updateLeadProgress({ id: progress.id, status: 'available' })

      if (this.fillExistedList(progress)) return
      this.clickUploadSection()
    },
    async handleFailedUploadProgress(progress) {
      this.$alert.error('Thao tác upload trước bị lỗi. Xin vui lòng upload lại.')
      await this.updateLeadProgress({ id: progress.id, status: 'available' })
      this.clickUploadSection()
    },
    fillExistedList(progress) {
      const existedList = get(progress, 'data.existedList')
      if (!Array.isArray(existedList) || !existedList.length) return false

      this.$emit('fillExistedList', existedList)
      return true
    },
    transformData(items = []) {
      const mapDict = this.configs
        .map(c => c.value.map(v => ({ key: v.value, value: v.key })))
        .flat()
        .reduce((o, i) => Object.assign(o, { [i.key]: i.value }), {})
      const keys = Object.keys(mapDict)
      items.forEach(item => {
        item.phone = item.phone || item[PHONE_ALIAS_KEY]
        delete item[PHONE_ALIAS_KEY]
        TRANSFORM_DATA_KEYS.forEach(k => {
          const value = item[k]
          item[k] = value ? keys.filter(_k => value.split(' // ').includes(_k)).map(_k => mapDict[_k]) : []
        })
      })
      this.setImportedItems(items)
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(file, { schema: IMPORT_SCHEMA })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      }
      const invalidPhoneIndex = readFileResult.rows.findIndex(item => !(item.phone || item[PHONE_ALIAS_KEY]))
      if (invalidPhoneIndex !== -1) {
        this.$alert.error(`Lỗi Dòng ${invalidPhoneIndex + 2} - Cột SĐT PHHS: required`)
        this.$loading.active = false
        return
      }
      this.transformData(readFileResult.rows)
      this.$emit('onImportSuccess')
      this.$loading.active = false
    },
  },
}
</script>
